<div class="content">
  <div class="wz-head">
    <span class="wz-eyebrow">World Creation Wizard</span>
    <h2 class="wz-title">Building <span class="gold">{{ mapName }}</span></h2>
  </div>

  <div class="wz-choice">
    <div class="wz-choice-chips">
      <span class="wz-chip is-free">Free</span>
      <span class="wz-chip is-plain">1 step</span>
    </div>
    <h3 class="wz-choice-name">Manual</h3>
    <p class="wz-choice-tag">"A stubbed wiki"</p>
    <p class="wz-lead">
      Full creative control with no AI writing. WorldTumbler builds the whole wiki structure (world overview, cultures,
      religions, states, provinces and cities) as clean templates. Every page is then yours to shape, edit and expand.
    </p>
  </div>

  <div class="wz-stats">
    <div class="wz-stat">
      <span>Credits needed</span>
      <strong>0</strong>
    </div>
    <div class="wz-stat">
      <span>Your balance</span>
      @if (isLoading) {
        <i class="wz-spinner" aria-label="Loading"></i>
      } @else {
        <strong>{{ worldCredits }}</strong>
      }
    </div>
  </div>

  <div class="wz-actions">
    <button type="button" class="btn btn-dark" (click)="onBack()">Back</button>
    <button type="button" class="btn btn-theme" (click)="onProceed()">Continue</button>
  </div>
</div>
